import { shooterGameModule } from '../../games/shooter';
import { rangerGameModule } from '../../games/ranger';
import { neonRelayGameModule } from '../../games/neonRelay';
import { triviaGameModule } from '../../games/trivia';
import { diceRollerGameModule } from '../../games/diceRoller';

export const PLAYER_ICON_STORAGE_PREFIX = 'arcade:player-icon:';
export const GAME_RELEASE_STATES = {
  released: 'released',
  development: 'development',
};

export function readReleasedLibraryOnly(search = window.location.search) {
  const params = new URLSearchParams(search);

  return (
    params.get('library') === 'released' ||
    params.get('released') === '1'
  );
}

export function getDefaultPlayableIcon(game) {
  return game.playableIcons?.[0] ?? null;
}

export function readSelectedPlayerIcons(storage, games = gameCatalog) {
  return games.reduce((selectedIcons, game) => {
    const defaultIcon = getDefaultPlayableIcon(game);

    if (!defaultIcon) {
      return selectedIcons;
    }

    const storedIconId = storage?.getItem(`${PLAYER_ICON_STORAGE_PREFIX}${game.id}`);
    const selectedIcon = game.playableIcons.find((icon) => icon.id === storedIconId) ?? defaultIcon;

    return {
      ...selectedIcons,
      [game.id]: selectedIcon.id,
    };
  }, {});
}

export function writeSelectedPlayerIcon(gameId, iconId, storage) {
  storage?.setItem(`${PLAYER_ICON_STORAGE_PREFIX}${gameId}`, iconId);
}

export function getVisibleGames({
  games = gameCatalog,
  isDevelopment = process.env.NODE_ENV !== 'production',
  includeDevelopment = process.env.REACT_APP_SHOW_DEVELOPMENT_GAMES === 'true',
  releasedOnly = readReleasedLibraryOnly(),
} = {}) {
  if (!releasedOnly && (isDevelopment || includeDevelopment)) {
    return games;
  }

  return games.filter((game) => game.releaseState === GAME_RELEASE_STATES.released);
}

export const gameCatalog = [
  triviaGameModule,
  shooterGameModule,
  rangerGameModule,
  neonRelayGameModule,
  diceRollerGameModule,
];
